import React, { useReducer } from "react";
import GlobalContext, { init } from "./GlobalContext";
import { SessionReducer } from "./reducers";

const GlobalState = props => {
  const [sessionState, dispatchSession] = useReducer(
    SessionReducer,
    init.session.state
  );

  let initialValue = {
    session: {
      state: sessionState,
      dispatch: dispatchSession
    }
  };
  return (
    <GlobalContext.Provider value={initialValue}>
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalState;
